import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSignalFair as fadSignalFair,
  faSignalGood as fadSignalGood,
  faSignalPerfect as fadSignalPerfect,
  faSignalStrong as fadSignalStrong,
  faSignalWeak as fadSignalWeak,
  faSortDown as fadSortDown,
  faSortUp as fadSortUp
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faAddressCard as falAddressCard,
  faAlignLeft as falAlignLeft,
  faApartment as falApartment,
  faArrowLeft as falArrowLeft,
  faArrowProgress as falArrowProgress,
  faBan as falBan,
  faBicycle as falBicycle,
  faCheck as falCheck,
  faBolt as falBolt,
  faBoltSlash as falBoltSlash,
  faBox as falBox,
  faBriefcase as falBriefcase,
  faBuilding as falBuilding,
  faBuildingColumns as falBuildingColumns,
  faBuildings as falBuildings,
  faBus as falBus,
  faCar as falCar,
  faCarSideBolt as falCarSideBolt,
  faCartShopping as falCartShopping,
  faChargingStation as falChargingStation,
  faCircleB as falCircleB,
  faCircleCheck as falCircleCheck,
  faCircleD as falCircleD,
  faCircleExclamation as falCircleExclamation,
  faCircleI as falCircleI,
  faCircleInfo as falCircleInfo,
  faCircleL as falCircleL,
  faCircleM as falCircleM,
  faCircleMinus as falCircleMinus,
  faCircleN as falCircleN,
  faCircleParking as falCircleParking,
  faCircleQuestion as falCircleQuestion,
  faCircleR as falCircleR,
  faCircleS as falCircleS,
  faCircleT as falCircleT,
  faCircleW as falCircleW,
  faCircleXmark as falCircleXmark,
  faCirclePlus as falCirclePlus,
  faClipboardList as falClipboardList,
  faCloud as falCloud,
  faCreditCard as falCreditCard,
  faCube as falCube,
  faCubes as falCubes,
  faEnvelope as falEnvelope,
  faEthernet as falEthernet,
  faEye as falEye,
  faEyeSlash as falEyeSlash,
  faFileInvoiceDollar as falFileInvoiceDollar,
  faFloppyDisk as falFloppyDisk,
  faForkKnife as falForkKnife,
  faFutbol as falFutbol,
  faGasPump as falGasPump,
  faGaugeHigh as falGaugeHigh,
  faGlobe as falGlobe,
  faHome as falHome,
  faHotel as falHotel,
  faHourglassEmpty as falHourglassEmpty,
  faIdCard as falIdCard,
  faLayerGroup as falLayerGroup,
  faListCheck as falListCheck,
  faLocation as falLocation,
  faLock as falLock,
  faMagnifyingGlass as falMagnifyingGlass,
  faMailbox as falMailbox,
  faMobileSignalOut as falMobileSignalOut,
  faMoneyBill1 as falMoneyBill1,
  faMugSaucer as falMugSaucer,
  faNote as falNote,
  faPlane as falPlane,
  faPlug as falPlug,
  faServer as falServer,
  faRacquet as falRacquet,
  faRobot as falRobot,
  faShareNodes as falShareNodes,
  faSliders as falSliders,
  faSignalStream as falSignalStream,
  faSimCard as falSimCard,
  faSitemap as falSitemap,
  faStairs as falStairs,
  faStore as falStore,
  faTaxi as falTaxi,
  faTag as falTag,
  faTrain as falTrain,
  faTrainSubwayTunnel as falTrainSubwayTunnel,
  faTrainTram as falTrainTram,
  faTree as falTree,
  faTrees as falTrees,
  faTriangleExclamation as falTriangleExclamation,
  faUser as falUser,
  faWifi as falWifi,
  faWrench as falWrench,
  faXmark as falXmark
} from '@fortawesome/pro-light-svg-icons';
import {
  faArrowDown,
  faArrowRightFromBracket,
  faArrowsRotate,
  faArrowUp,
  faArrowUpToLine,
  faChevronDown,
  faChevronsLeft,
  faChevronsRight,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faClock,
  faCopy,
  faCube,
  faEllipsisVertical,
  faFileLines,
  faHashtag,
  faKey,
  faArrowUpRightFromSquare,
  faLocationDot,
  faPen,
  faPenToSquare,
  faSpinner,
  faTag,
  faTrash,
  faTrashCan,
  faTurnDownRight,
  faUnlink
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowDownWideShort as fasArrowDownWideShort,
  faArrowRight as fasArrowRight,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faArrowRotateRight as fasArrowRotateRight,
  faArrowsRotate as fasArrowsRotate,
  faArrowUpArrowDown as fasArrowUpArrowDown,
  faBan as fasBan,
  faBars as fasBars,
  faBatteryBolt as fasBatteryBolt,
  faBoltLightning as fasBoltLightning,
  faCaretDown as fasCaretDown,
  faCaretUp as fasCaretUp,
  faChargingStation as fasChargingStation,
  faCheck as fasCheck,
  faCircleCheck as fasCircleCheck,
  faCircleExclamation as fasCircleExclamation,
  faCircleInfo as fasCircleInfo,
  faCircleSmall as fasCircleSmall,
  faCircleXmark as fasCircleXmark,
  faCodeSimple as fasCodeSimple,
  faDatabase as fasDatabase,
  faDoorOpen as fasDoorOpen,
  faFileCsv as fasFileCsv,
  faFingerprint as fasFingerprint,
  faForward as fasForward,
  faGaugeHigh as fasGaugeHigh,
  faGear as fasGear,
  faGlobe as fasGlobe,
  faHandshakeAlt as fasHandshakeAlt,
  faHandshakeAngle as fasHandshakeAngle,
  faHome as fasHome,
  faInfo as fasInfo,
  faLink as fasLink,
  faLocationDot as fasLocationDot,
  faMagnifyingGlass as fasMagnifyingGlass,
  faMailbox as fasMailbox,
  faMoneyBillTransfer as fasMoneyBillTransfer,
  faPercent as fasPercent,
  faPlay as fasPlay,
  faPlug as fasPlug,
  faPlus as fasPlus,
  faPowerOff as fasPowerOff,
  faRefresh as fasRefresh,
  faRepeat as fasRepeat,
  faReplyAll as fasReplyAll,
  faRightLeftLarge as fasRightLeftLarge,
  faRotateRight as fasRotateRight,
  faScrewdriverWrench as fasScrewDriverWrench,
  faSendBack as fasSendBack,
  faShuffle as fasShuffle,
  faSignal as fasSignal,
  faSlidersSimple as fasSlidersSimple,
  faSolarPanel as fasSolarPanel,
  faSort as fasSort,
  faStop as fasStop,
  faTemperatureThreeQuarters as fasTemperatureThreeQuarters,
  faTimer as fasTimer,
  faTrash as fasTrash,
  faUnlock as fasUnlock,
  faUpload as fasUpload,
  faUser as fasUser,
  faUserHelmetSafety as fasUserHelmetSafety,
  faWifi as fasWifi,
  faXmark as fasXmark,
  faZap as fasZap
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import type { App, Plugin } from 'vue';

export function createIcon(): Plugin {
  return {
    install: (app: App) => {
      library.add(
        // Light
        falNote,
        falAddressCard,
        falAlignLeft,
        falApartment,
        falArrowLeft,
        falArrowProgress,
        falBan,
        falBicycle,
        falBox,
        falBriefcase,
        falBuilding,
        falBuildings,
        falCirclePlus,
        falClipboardList,
        falCreditCard,
        falCube,
        falCubes,
        falBuildingColumns,
        falBus,
        falCar,
        falCarSideBolt,
        falCartShopping,
        falChargingStation,
        falCircleB,
        falCircleCheck,
        falCircleD,
        falCircleExclamation,
        falCircleI,
        falCircleInfo,
        falCircleL,
        falCircleM,
        falCircleMinus,
        falCircleN,
        falCircleParking,
        falCircleQuestion,
        falCircleR,
        falCircleS,
        falCircleT,
        falCircleW,
        falCircleXmark,
        falCloud,
        falEnvelope,
        falEye,
        falEyeSlash,
        falEthernet,
        falFileInvoiceDollar,
        falFloppyDisk,
        falForkKnife,
        falFutbol,
        falGasPump,
        falGaugeHigh,
        falGlobe,
        falHome,
        falHotel,
        falHourglassEmpty,
        falIdCard,
        falCheck,
        falLayerGroup,
        falListCheck,
        falLocation,
        falLock,
        falMailbox,
        falMagnifyingGlass,
        falMobileSignalOut,
        falMoneyBill1,
        falMugSaucer,
        falPlane,
        falRacquet,
        falRobot,
        falShareNodes,
        falSignalStream,
        falSimCard,
        falSitemap,
        falStairs,
        falStore,
        falTag,
        falTaxi,
        falTrain,
        falTrainSubwayTunnel,
        falTrainTram,
        falTree,
        falTrees,
        falUser,
        falWifi,
        falBolt,
        falBoltSlash,
        falPlug,
        falServer,
        falSliders,
        falTriangleExclamation,
        falWrench,
        falXmark,

        // Regular
        faArrowDown,
        faArrowRightFromBracket,
        faArrowUp,
        faArrowUpToLine,
        faArrowsRotate,
        faChevronDown,
        faChevronUp,
        faChevronsLeft,
        faChevronsRight,
        faCircle,
        faCircleNotch,
        faClock,
        faCopy,
        faCube,
        faEllipsisVertical,
        faArrowUpRightFromSquare,
        faFileLines,
        faHashtag,
        faKey,
        faLocationDot,
        faPenToSquare,
        faSpinner,
        faTrash,
        faTrashCan,
        faTurnDownRight,
        faUnlink,
        faPen,
        faTag,

        // Solid
        fasArrowDownWideShort,
        fasArrowRight,
        fasChevronLeft,
        fasChevronRight,
        fasArrowRotateRight,
        fasArrowsRotate,
        fasArrowUpArrowDown,
        fasBan,
        fasBars,
        fasBatteryBolt,
        fasBoltLightning,
        fasCaretDown,
        fasCaretUp,
        fasChargingStation,
        fasCheck,
        fasCircleCheck,
        fasCircleExclamation,
        fasCircleInfo,
        fasCircleSmall,
        fasCircleXmark,
        fasCodeSimple,
        fasDatabase,
        fasDoorOpen,
        fasFileCsv,
        fasFingerprint,
        fasForward,
        fasGaugeHigh,
        fasGear,
        fasGlobe,
        fasHandshakeAlt,
        fasHandshakeAngle,
        fasHome,
        fasInfo,
        fasLink,
        fasLocationDot,
        fasMagnifyingGlass,
        fasMailbox,
        fasMoneyBillTransfer,
        fasPercent,
        fasPlay,
        fasPlug,
        fasPlus,
        fasPowerOff,
        fasRefresh,
        fasRepeat,
        fasReplyAll,
        fasRotateRight,
        fasScrewDriverWrench,
        fasSendBack,
        fasShuffle,
        fasSignal,
        fasSlidersSimple,
        fasSort,
        fasSolarPanel,
        fasStop,
        fasTemperatureThreeQuarters,
        fasTimer,
        fasTrash,
        fasUnlock,
        fasUpload,
        fasUser,
        fasUserHelmetSafety,
        fasWifi,
        fasXmark,
        fasZap,
        fasRightLeftLarge,

        // Duo-tone
        fadSortDown,
        fadSortUp,
        fadSignalWeak,
        fadSignalFair,
        fadSignalGood,
        fadSignalStrong,
        fadSignalPerfect
      );

      app.component('font-awesome-icon', FontAwesomeIcon);
      app.component('font-awesome-layers', FontAwesomeLayers);
    }
  };
}
